import { render, staticRenderFns } from "./Basics.vue?vue&type=template&id=28243230&scoped=true&"
import script from "./Basics.vue?vue&type=script&lang=js&"
export * from "./Basics.vue?vue&type=script&lang=js&"
import style0 from "./Basics.vue?vue&type=style&index=0&id=28243230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28243230",
  null
  
)

export default component.exports